<template>
  <div class="scroll-nav-bar">
    <div ref="main" class="main">
      <div ref="items" class="items">
        <div
          v-for="(item, index) in labels"
          ref="item"
          :key="index"
          class="item"
          :class="{ active: index === activeIndex }"
          @click="clickHandler(index)"
        >
          <slot :index="index" :label="item">
            <span v-html="item"></span>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
export default {
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      timer: null,
      scroll: null
    }
  },
  watch: {
    activeIndex() {
      clearTimeout(this.timer)
      this.timer = setTimeout(this.adjust, 500)
    }
  },

  mounted() {
    this.initBScroll()
    this.adjust()
  },

  beforeDestroy() {
    if (this.scroll) {
      this.scroll.destroy()
    }
  },

  methods: {
    initBScroll() {
      if (this.$refs.item) {
        const allWidth = this.$refs.item.reduce(
          (pre, act) => pre + act.offsetWidth,
          0
        )
        this.$refs.items.style.width = `${allWidth}px`
        this.scroll = new BScroll(this.$refs.main, {
          scrollX: true,
          click: true
        })
      }
    },
    clickHandler(index) {
      if (index === this.activeIndex) return
      this.$emit('change', index)
      this.adjust()
    },
    adjust() {
      this.$nextTick(() => {
        if (!this.$refs.item || this.$refs.item[this.activeIndex]) {
          return
        }
        const actItem = this.$refs.item[this.activeIndex]
        const mainWidth = this.$refs.main.offsetWidth
        const itemCentSize = actItem.offsetLeft + actItem.offsetWidth / 2
        const mainCentSize = this.$refs.main.offsetWidth / 2
        const diff = mainCentSize - itemCentSize
        const overflowWidth = this.$refs.items.scrollWidth - mainWidth
        // 没有滚动区域
        if (overflowWidth <= 0) {
          return
        }
        // 处理靠前元素滚动逻辑
        if (diff > 0) {
          this.scroll.scrollTo(0, 0, 300)
          return
        }
        // 处理靠后元素滚动逻辑
        if (itemCentSize > overflowWidth && diff + overflowWidth < 0) {
          this.scroll.scrollTo(-overflowWidth, 0, 300)
          return
        }
        this.scroll.scrollTo(diff, 0, 300)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.scroll-nav-bar {
  .main {
    position: relative;
    overflow: hidden;
    transition: all;
    height: 100%;
  }
  .items {
    min-width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    transition: all;
  }
  .item {
    height: 100%;
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }
}
</style>
